import { Component, ElementRef, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-a-propos',
  templateUrl: './a-propos.component.html',
  styleUrls: ['./a-propos.component.css'],
})
export class AProposComponent implements OnInit {
  zoom: boolean = false;
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.zoom = false;
    $(this.elementRef.nativeElement).hide().fadeIn(1500);
  }

  activeClass() {
    this.zoom = !this.zoom;
    if (this.zoom == true) {
      $('#imgTarif').addClass('fullscreen');
    } else {
      $('#imgTarif').removeClass('fullscreen');
    }
  }
}
